import type { Item } from './item-types';
import { useProperty, type ItemProperty } from './item-property-table';
import { dataTransformers } from '../shared/data-transformers';
import { ItemAPI } from '../../api/item';

export function makeItemInformationProperties(item: Item): ItemProperty[] {
  let itemInformationProperties: ItemProperty[] = [];

  itemInformationProperties.push(useProperty('Type', item.package_type_field));

  const capacity = item.uoms?.find((u) => u.unit_id.includes('CAP-'));
  if (capacity) {
    itemInformationProperties.push(
      useProperty(
        'Capacity',
        capacity.unit_size,
        dataTransformers.unit(capacity.unit_description, 1)
      )
    );
  }

  if (item.neck_finish_field && item.neck_finish_field.length > 0) {
    itemInformationProperties.push(
      useProperty('Neck Finish', item.neck_finish_field)
    );
  }

  if (item.material_field) {
    itemInformationProperties.push(
      useProperty('Material', item.material_field)
    );
  }

  itemInformationProperties.push(
    useProperty('Made in', item.country_of_origin_field)
  );

  const useDiameter = item.length && item.length === item.width;
  if (useDiameter && item.length) {
    itemInformationProperties.push(
      useProperty('Diameter', item.length, dataTransformers.inches)
    );
  }

  if (item.height) {
    itemInformationProperties.push(
      useProperty('Height', item.height, dataTransformers.inches)
    );
  }

  if (!useDiameter && item.width) {
    itemInformationProperties.push(
      useProperty('Width', item.width, dataTransformers.inches)
    );
  }

  if (!useDiameter && item.length) {
    itemInformationProperties.push(
      useProperty('Length', item.length, dataTransformers.inches)
    );
  }
  return itemInformationProperties;
}

export function makeLabelProperties(item: Item): ItemProperty[] {
  let props = [];
  if (item.label_type_field) {
    props.push(useProperty('Shape', item.label_type_field));
  }
  if (item.label_width_field) {
    props.push(
      useProperty(
        'Max Label Width',
        item.label_width_field,
        dataTransformers.inches
      )
    );
  }
  if (item.label_height_field) {
    props.push(
      useProperty(
        'Max Label Height',
        item.label_height_field,
        dataTransformers.inches
      )
    );
  }

  return props;
}
export function makePrintProperties(item: Item): ItemProperty[] {
  let props = [];
  if (item.print_width_field) {
    props.push(
      useProperty(
        'Max Print Width',
        item.print_width_field,
        dataTransformers.inches
      )
    );
  }
  if (item.print_height_field) {
    props.push(
      useProperty(
        'Max Print Height',
        item.print_height_field,
        dataTransformers.inches
      )
    );
  }
  return props;
}
export async function getTemplateUrl(
  item: Item,
  templateType: string
): Promise<string | undefined> {
  const isPrintTemplate = templateType === 'print';
  try {
    const { data: templateUrl } = await ItemAPI.getLabelTemplateUrl({
      itemId: item.item_id,
      templateType: templateType,
      labelType: item.label_type_field,
      height: isPrintTemplate
        ? item.print_height_field
        : item.label_height_field,
      width: isPrintTemplate ? item.print_width_field : item.label_width_field,
    });
    return templateUrl;
  } catch {
    return undefined;
  }
}
